import "./HighConvertingHotelWebsiteDesignOptimization.module.css";
import Header from "@/reusable_sections/Header";
import Hero from "./sections/Hero";
import Pillars from "./sections/Pillars";
import Review from "./sections/Review";
import Footer from "@/reusable_sections/Footer";
export default function HighConvertingHotelWebsiteDesignOptimizationPage() {
  return <div>
      <Header />
      <Hero />
      <Pillars />
      <Review />
      <Footer />
    </div>;
}